import './EventDetails.scss';
import { useTranslation } from 'react-i18next';

function EventDetailsHeader({ 
  handleViewAllClick,
  numberOfEvents,
  selectedEventIndex,
  setSelectedEventIndex, 
  viewAll,
  noData
  }) {

  const { t } = useTranslation();

  const handlePreviousClick = () => {
    if(selectedEventIndex > 0) setSelectedEventIndex(selectedEventIndex-1);
  }

  const handleNextClick = () => {
    if(selectedEventIndex < numberOfEvents - 1) setSelectedEventIndex(selectedEventIndex+1);
  }

  return (
      <div className="c-event-details-header">
        <span className="header__title">{t('myBlockMonth.eventDetails')}</span>
        {!noData && (
          <>
            <span className="header__view-all" onClick={handleViewAllClick}>{viewAll ? t('myBlockMonth.viewLessEvents') : t('myBlockMonth.viewAllEvents')}</span>
            {!viewAll && (
              <div className="c-prev-next">
                <button 
                  className={selectedEventIndex !== 0 ? 'btn-prev-next' : 'btn-prev-next btn-prev-next--disabled'} 
                  onClick={() => handlePreviousClick()}
                > 
                  <span className="icon-chevron-thin-left"></span>Previous
                </button>
                <button 
                  className={selectedEventIndex !== numberOfEvents - 1 ? 'btn-prev-next btn-prev-next--ml' : 'btn-prev-next btn-prev-next--ml btn-prev-next--disabled'} 
                  onClick={() => handleNextClick()}
                > 
                  Next<span className="icon-chevron-thin-right"></span>
                </button>
              </div>
            )}
          </>
        )}      
      </div>
  );
}

export default EventDetailsHeader;
